<script>
  import { _ as t } from "svelte-i18n";
  import { getUrlFromId } from "../../sanityClient";

  import Download from "components/Download.svelte";
  import Title from "components/Title.svelte";

  export let documents;
</script>

<div class="wrapper">
  <Title>{$t("presentations")}</Title>

  {#if documents}
    {#each documents as document (document._key)}
      <div class="item">
        {#if document.title ? document.title : "-"}
          <div class="attachments">
            <Download
              text={document.title}
              href={getUrlFromId(document.file.asset._ref)}
            />
          </div>
        {/if}
      </div>
    {/each}
  {/if}
</div>

<style>
  .wrapper {
    margin: 4rem auto 0;
    max-width: 700px;
  }

  .item {
    margin: 32px 0;
  }

  @media only screen and (min-width: 600px) {
    .attachments {
      display: grid;
      grid-template-columns: 50% 50%;
    }

    .item {
      margin: 0;
    }
  }
</style>
